/**
 * AUTO-GENERATED DATA — do not edit annual values by hand.
 * Regenerate: `npm run generate:bwp-eia861` (from repo root: analysis script sync_frontend_bundle.py).
 */
import type { Eia861AnnualObservation } from './types';
import annualBundle from './data/bwpEia861Annual.generated.json';

export const BWP_EIA_UTILITY_ID = '2507';

export const BURBANK_GEOID = '0608954';
export const BURBANK_GEOID_NUMERIC = 608954;
export const BURBANK_LOCATION_NAME = 'Burbank';
export const BURBANK_CLIMATE_PLANS_SLUG = 'burbank';

export const BWP_EXPECTED_UTILITY_NAME = 'City of Burbank Water and Power';

export const BWP_OBSERVATIONS_SOURCE = {
  sourceCsvPath: annualBundle.sourceCsvPath,
  sourceCsvSha256: annualBundle.sourceCsvSha256,
  generatedOn: annualBundle.generatedOn,
} as const;

function toObservation(raw: (typeof annualBundle.observations)[number]): Eia861AnnualObservation {
  return {
    year: raw.year,
    eiaUtilityId: raw.eiaUtilityId,
    utilityName: raw.utilityName,
    state: raw.state,
    residentialMwh: raw.residentialMwh,
    commercialMwh: raw.commercialMwh,
    industrialMwh: raw.industrialMwh,
    transportationMwh: raw.transportationMwh,
    otherMwh: raw.otherMwh,
    totalMwh: raw.totalMwh,
    residentialCustomers: raw.residentialCustomers,
    commercialCustomers: raw.commercialCustomers,
    industrialCustomers: raw.industrialCustomers,
    sourceFile: raw.sourceFile,
    extractionStatus: raw.extractionStatus === 'extracted' ? 'extracted' : 'verified_control',
  };
}

export const BWP_EIA861_ANNUAL_OBSERVATIONS: Eia861AnnualObservation[] =
  annualBundle.observations.map(toObservation);
